<template>
  <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
    <div class="card rounded-8">
      <img class="card-img-top" :src="course.image" :alt="course.name">
      <div class="card-body p-3 pb-2">
        <div class="mb-3">
          <span class="badge badge-secondary text-primary bg-utel-v2-secondary">Curso</span>
        </div>
        <div class="text-card-normal mb-3">
          <h5 class="card-title course-title">{{ course.name }}</h5>
          <p class="card-text short-description-diploma">{{ strippedContent(course.content) }}</p>
        </div>
        <div class="text-center d-flex justify-content-center">
          <button 
            type="button" 
            class="btn bg-utel-v2-secondary sin-borde text-primary rounded-8 mx-1 my-sm-2 pt-2"
            title="Ver información del curso" 
            @click="$emit('view-info', course)"
          >
            <i class="fa-solid fa-eye"></i>
          </button>
          <button 
            class="btn bg-utel-v2-secondary sin-borde text-primary rounded-8 mx-1 my-sm-2 pt-2"
            @click="$emit('add-course', course)"
          >
            Agregar curso
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CourseCard',
  
  props: {
    course: {
      type: Object,
      required: true
    }
  },
  
  emits: ['view-info', 'add-course'],
  
  methods: {
    strippedContent(text) {
      if (!text) return ''
      const regex = /(<([^>]+)>)/ig
      return text.replace(regex, '')
    }
  }
}
</script>

<style scoped>
.course-title {
  height: 57px;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

.short-description-diploma {
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
}
</style>